import Vue from "vue"
import App from "./App.vue"
import router from "@/router"
import store from "@/store"
import ElementUI from 'element-ui'
Vue.use(ElementUI, { size: 'mini' })
import 'xe-utils'
import VXETable from 'vxe-table'
Vue.use(VXETable, { size: 'mini' })
import Contextmenu from 'v-contextmenu'
Vue.use(Contextmenu)
import Clipboard from 'vue-clipboard2'
Vue.use(Clipboard)
import animated from 'animate.css'
Vue.use(animated)
import { Draggable } from 'draggable-vue-directive'
Vue.directive('draggable', Draggable)

VXETable.interceptor.add('event.clearActived', (params, event) => {
  if (params.$columnIndex == 2 || params.$columnIndex == 3 || params.$columnIndex == 7 || params.$columnIndex == 8 || params.$columnIndex == 10) {
    return false
  }
  return true
})

import '@/styles/index.scss'


// 自定义全局组件
import plugin from '@/components'
Vue.use(plugin)

// 自定义全局属性
import api from '@/api'
Vue.prototype.$api = api

// 自定义全局钩子
import '@/filter'
import '@/icons'
import "@/directive"

Vue.config.productionTip = false

String.prototype.replaceAll = function (s1, s2) {
  return this.replace(new RegExp(s1, 'gm'), s2)
}

Vue.prototype.$qiniu = null

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")